const Notifications = {
  methods: {
    notificationIcon(type) {
      switch (type) {
        case 'reminder':
          return '$sl-alarm'
        case 'urgent':
          return '$sl-alert-octagram'
        case 'confirmation':
          return '$sl-save'
        default:
          return '$sl-alarm'
      }
    },
    notificationType(type) {
      switch (type) {
        case 'Book':
          return this.$t('labels.the-ebook')
        case 'Application':
          return this.$t('labels.application')
        default:
          return 'Notifiering'
      }
    },
    notificationTypeIcon(type) {
      switch (type) {
        case 'Book':
          return '$sl-ebook-approve'
        case 'Application':
          return '$sl-add-application'
        default:
          return '$sl-alarm'
      }
    },
    // eslint-disable-next-line complexity
    notificationRoute(type, id, additionalInfo, user) {
      switch (type) {
        case 'TradeCertificate': {
          this.$nextTick(() => {
            this.$router.push({name: 'PersonQualifications'})
          })
          break;
        }
        case 'Book':
          if (!(additionalInfo && additionalInfo.reportId)) {
            if (this.$route && this.$route.name === 'EbookEducationStart' && this.$route.params.id === id) {
              this.$nextTick(() => {
                // eslint-disable-next-line no-empty-function
                this.$router.push('/').catch(() => {})
              })
            }
            this.$nextTick(() => {
              this.$router.push({name: 'EbookEducationStart', params: {id}})
            })
          } else if (user && user.isCompanyUser) {
            this.$nextTick(() => {
              this.$router.push({
                name: 'InstructorApprenticesReport',
                params: {bookId: id, reportId: additionalInfo.reportId}
              })
            })
          } else {
            this.$nextTick(() => {
              this.$router.push({name: 'EbookReportNew', params: {id, reportId: additionalInfo.reportId}})
            })
          }
          break

        case 'Application':
          if (additionalInfo && additionalInfo.companyId > 0 && id > 0) {
            if (this.$route && this.$route.name === 'AdminApplicationStart') {
              this.$nextTick(() => {
                // eslint-disable-next-line no-empty-function
                this.$router.push('/').catch(() => {})
              })
            }
            if (user && user.isCompanyUser) {
              this.$nextTick(() => {
                this.$router.push({
                  name: 'AdminApplicationStart',
                  params: {id: additionalInfo.companyId, application_id: id}
                })
              })
            } else {
              if (
                this.$route &&
                (this.$route.name === 'AdminApplicationStart' || this.$route.name === 'ApplicationStart')
              ) {
                this.$nextTick(() => {
                  // eslint-disable-next-line no-empty-function
                  this.$router.push('/').catch(() => {})
                })
              }
              this.$nextTick(() => {
                this.$router.push({
                  name: 'ApplicationStart'
                })
              })
            }
          }
          break

        case 'DistanceOrder':
          if (additionalInfo && additionalInfo.companyId > 0 && id > 0 && user && user.isDistanceEducationAdministrator) {

            this.$nextTick(() => {
              this.$router.push({
                name: 'CompanyDistanceOrder',
                params: {companyId: additionalInfo.companyId,distance_order_id:id}
              })
            })
          }

          break
        default:
          return ''
      }
    }
  }
}

export default Notifications
